<template>
  <v-data-table
    :headers="headers"
    :items="dates"
  >
    <template v-slot:item.name="{ item }">
      {{ item.name }}
    </template>
    <template v-slot:item.date="{ item }">
      <span class="nowrap">{{ item.date | formatDate }}</span>
    </template>
    <template v-slot:item.description="{ item }">
      <small>{{ item.description }}</small>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row>
        <v-btn
          icon
          small
          @click="$emit('EDIT_LD_DATE', item)"
          :disabled="!canUserEdit"
          >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <SubmitButton
          icon="mdi-delete"
          small
          :disabled="!canUserEdit"
          @click="$emit('DELETE_LD_DATE', item)"
        />
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'LiquidatedDamagesDateTable',
  props: {
    contract: Object,
    dates: Array,
    currency: Object,
    canUserEdit: Boolean
  },
  data () {
    return {
      headers: this.getHeaders()
    }
  },
  methods: {
    getHeaders () {
      return [
        { text: this.$t('common.name'), value: 'name' },
        { text: this.$t('lds.date'), value: 'date' },
        { text: this.$t('common.description'), value: 'description' },
        { text: '', value: 'actions', sortable: false, width: 120 }
      ]
    }
  }
}
</script>
